const i4_Sort = {
	instances: [],

	factory: function(id, ajax_parameter) {
		var instance = $.extend({}, i4_Sort_instance);
		instance.initialize(id, ajax_parameter);
		this.instances.push(instance);
		return instance;
	},

	get: function($element) {
		var result = false;

		if (typeof $element === "string") {
			$element = $('#'+$element);
		}

		$(this.instances).each(function(i, item){
			if (item.$container.find($element).length) {
				result = item;
				return false;
			}
		});

		return result;
	}
};

var i4_Sort_instance = {
	id: '', // sortierungs container
	ajax_parameter: '',
	new_order_id: '', // hidden field id für new_order (send_type post)

	current_order: [],
	new_order: [],
	moved_element_id: '', // id of element in database
	moved_item: '', // dom-element
	prev_item: '',
	next_item: '',

	handles: 'li', // elemente mit welche man verschieben kann
	tag: 'li', // elemente welche verschoben werden sollen
	only: '', // nur elemente mit einer bestimmten class verschieben
	constraint: 'y', // default bewegungseinschraenkung bei Sortable

	send_type: 'ids', // 'ids' für navigation, 'list' für aggregator, 'post' für form_element_item
	item_selector: '', // @todo: delete
	$items: null,
	sortable_instance: null,
	group: null, // 20200127/urs: if set, drop targets can be outside current branch. save_changes() not yet ready for this

	/**
	 * @param id: id des sortierungs-containers.
	 * @param ajax_parameter: pfad zum ajax php file welches die sortierung uebernimmt.
	 */
	initialize: function(id, ajax_parameter) {
		if (typeof id == 'string') {
			this.$container = $('#'+id);
		} else {
			this.$container = id;
		}

		if (ajax_parameter != undefined) {
			this.ajax_parameter = ajax_parameter;
		}

		this.$container.addClass('ui-sortable-container');
	},

	/**
	 * setter
	 */
	set_tag: function (tag) { this.tag = tag; return this; },
	set_only: function (only) { this.only = only; return this; },
	set_handles: function(str){	this.handles = str; return this; },
	set_constraint: function (constraint) {
		if (constraint == 'horizontal') { constraint = 'x'; }
		if (constraint == 'vertical') { constraint = 'y'; }
		this.constraint = constraint;
		return this;
	},
	set_send_type: function (send_type) { this.send_type = send_type; return this; },
	set_new_order_id: function (new_order_id) { this.new_order_id = new_order_id; return this; },
	set_group: function (group) { this.group = group; return this; },

	/**
	 * startet sortable.
	 */
	run: function() {
		if (this.$container.length) {
			// generate item selector
			var item_selector_inner = '> '+this.tag;
			if (this.only != '') {
				item_selector_inner += '.'+this.only;
			}
			this.$items = this.$container.find(item_selector_inner);

			// create a temp-hander, where no handler exists
			this.$items.find(' > .temp_handler').remove();
			this.$items.each((function(i, item) {
				if (!$(item).find('.'+this.handles).length) {
					$(item).append(
						$('<span></span>').
						addClass(this.handles).
						addClass('temp_handler').
						hide()
					);
				}
			}).bind(this));

			var overlap = this.constraint;
			if (overlap == '') {
				overlap = 'x';
			}

			this.$container.find('.' + this.handles).css('cursor', 'move');

			this.sortable_instance = Sortable.create(this.$container[0], {
				handle: '.' + this.handles,
				group: this.group,
				ghostClass: 'ui-sortable-container--active',
				chosenClass: 'ui-sortable-placeholder',
				dragOverBubble: true,
				animation: 0,

				onStart: function(event, ui) {
					event.target.classList.add('ui-sortable-container--active');
					if (overlap === 'x') {
						event.target.classList.add('ui-sortable-container--horizontal');
					} else if (overlap === 'y') {
						event.target.classList.add('ui-sortable-container--vertical');
					}
				},

				onEnd: function(event, ui) {
					event.target.classList.remove('ui-sortable-container--active');
					event.target.classList.remove('ui-sortable-container--horizontal');
					event.target.classList.remove('ui-sortable-container--vertical');
				},

				onMove: (function(event, ui) {
					var item = event.dragged;
					// console.log('DRAGGABLE ITEM ID', item.dataset.id);
					// this.moved_item = item.dataset.id;
				}).bind(this),

				onUpdate: (function(event, ui) {
					// console.log(event.item.dataset.id);
					this.update_order('new');
					this.save_changes(event.item.dataset.id);
				}).bind(this)
			});

			this.update_order('current');
		}
	},

	/**
	 * zustaendig fuer das updaten der beiden order-arrays.
	 * @param which: welches array soll updated werden. new oder current.
	 */
	update_order: function(which) {
		var order = this.sortable_instance.toArray();

		if(which == 'current'){ this.current_order = order; }
		if(which == 'new'){ this.new_order = order; }
	},

	/**
	 * speichert die veraenderung mit ajax
	 */
	save_changes: function(moved_item) {
		var params = '';
    // console.log('SENDTYPE', this.send_type);
		// für navigation (default)
		if (this.send_type == 'ids') {

			// ermitteln welches das neue uebergeordnete element ist
			$(this.new_order).each((function(i, item){
				if(parseInt(item) == moved_item){
					this.prev_item = this.new_order[i-1];
					this.next_item = this.new_order[i+1];
				}
			}).bind(this));

			if (this.prev_item == '') {
				this.prev_item = 0;
			}
			if (this.next_item === undefined) {
				this.next_item = 0;
			}

			params = '&call=move&move_id='+moved_item+'&preceding_id='+this.prev_item+'&following_id='+this.next_item;
		}
		// für aggregator
		if (this.send_type == 'list') {
			params = '&call=move&new_order='+this.new_order;
		}
		// für form element items
		if (this.send_type == 'post') {
			if (this.new_order_id != '') {
				$('#'+this.new_order_id).val(this.new_order);
			}
		}

		if (this.send_type != 'post') {
			i4_Message.progress();
			i4_Ajax.factory().
				set_parameter(this.ajax_parameter+params).
				set_option({
					on_complete: (function(text) {
						i4_Message.show(i4_Translation.get().saved_changes);
					}).bind(this)
				}).
				run();
		}

		this.update_order('current');
	}
};
